import { getDecodedConsulData } from '@shared/lib/consul'
import { PercentFeeServiceType } from '../model/tsp.types'

export const fetchIsServiceWithPercentFeeById = async (id: string) => {
  const data = await getDecodedConsulData<{ percentFeeServices: PercentFeeServiceType[] }>(
    '/services/percent-fee-services/value'
  )

  return data.percentFeeServices.includes(id)
}
